import { FC } from 'react';
import { IFactoid } from 'shared/types/houseInfo/factoid';
import styles from './FactoidItem.css';
import { ArticleParagraph1, ArticleParagraph2 } from '@cian/ui-kit';

export const FactoidItem: FC<IFactoid> = ({ title, icon, value }) => {
  return (
    <div className={styles['factoid']}>
      <img src={icon} className={styles['icon']} />
      <div className={styles['text']}>
        <ArticleParagraph2 color="gray60_100">{title}</ArticleParagraph2>
        <ArticleParagraph1 fontWeight="bold">{value}</ArticleParagraph1>
      </div>
    </div>
  );
};
